import React, { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useRequestsQueryState from '../../hooks/useRequestsQueryState';
import HorizontalBarChart from '../charts/HorizontalBarChart/HorizontalBarChart';
import useFilterState from '../../hooks/useFilterState';
import { horizontalChartPlaceholderType } from '../../constants/common';
import { ascSort } from '../../helpers/ascSort';

const HorizontalChart = ({
  showNoIndicated = false,
  filter,
  itemKey = 'id',
  title,
  outlined,
  className,
  style,
  placeholderType = horizontalChartPlaceholderType.EXECUTER,
  onItemClick,
  valueKey = 'value',
  nullContent,
}) => {
  const [filterState, setFilterState] = useFilterState(filter);
  const [sortItems, setSortItems] = useState([]);

  const items = useSelector(
    (state) => state.statisticsStore.chartsRequests[filter.name]
  );

  const requestsState = useRequestsQueryState();

  const data = useMemo(() => {
    if (items?.length > 0) {
      return showNoIndicated
        ? items
        : items.filter((item) => item[itemKey] !== 0);
    } else {
      return [];
    }
  }, [items, showNoIndicated]);

  const handleItemClick = (entity) => {
    if (typeof onItemClick === 'function') {
      onItemClick(entity);
    } else {
      if (filterState.includes(entity[itemKey])) {
        setFilterState((prev) =>
          prev.filter((item) => item !== entity[itemKey])
        );
      } else {
        setFilterState((prev) => [...prev, entity[itemKey]]);
      }
    }
  };

  const isActiveItem = (item) => filterState.includes(item[itemKey]);

  useEffect(() => {
    let sortItems = [];

    if (data.length) {
      sortItems = ascSort(data.slice(), valueKey);
    }

    setSortItems(sortItems);
  }, [data]);

  return (
    <HorizontalBarChart
      onItemClick={handleItemClick}
      title={title}
      data={sortItems}
      className={className}
      isActiveItem={isActiveItem}
      outlined={outlined}
      loading={requestsState?.isFetching}
      style={style}
      placeholderType={placeholderType}
      valueKey={valueKey}
      nullContent={nullContent}
    />
  );
};

export default HorizontalChart;
